export const CONSUMPTION_STATUS_COLORS: Record<string, string> = {
  not_started: 'default',
  in_progress: 'blue',
  completed: 'green',
};

export const PRODUCT_FORMAT_COLORS: Record<string, string> = {
  ebook: 'purple',
  audio: 'orange',
};

export const PRODUCT_VARIANT_COLORS: Record<string, string> = {
  full: 'green',
  preview: 'blue',
  demo: 'gold',
};

/** Why server-side validation rejected a segment. */
export const SEGMENT_ERROR_REASON_COLORS: Record<string, string> = {
  invalid_progression_range: 'red',
  invalid_segment_order: 'orange',
  segment_too_long: 'gold',
  invalid_timestamp: 'volcano',
  unknown_product: 'magenta',
};

/** Publisher-settlement outcome; `null` (pending pool) is tagged separately. */
export const SEGMENT_SETTLEMENT_COLORS: Record<string, string> = {
  settled: 'green',
  preview: 'blue',
  skipped_pre_contract: 'default',
};
